import { Destinations } from ".";

const DestinationsSection = () => {
  return <Destinations />;
};

export default DestinationsSection;
